<template>
  <div class="">
    <navbar></navbar>
    <main class="main" role="main">
      <div class="py-5 bg-light">
        <div class="container">
          <div class="col-md-12 p-0">
            <router-link to="top">{{$t('ordertop.myhome')}}</router-link> / <router-link to="info">{{$t('Settingspage.SettingsTop')}}</router-link> / {{$t('UpdateInfoTop.UpdateInfo')}}
            <div class="mt-4 row justify-content-start col-12 col-sm-9 col-md-7 col-lg-5">
              <ul class="nav nav-tabs wizard pr-0 pl-0">
                <li :class="{active:step===1,completed:step>1}"><a>{{$t('UpdateInfoTop.Input')}}</a></li>
                <li :class="{active:step===2,completed:step>2}"><a>{{$t('UpdateInfoTop.Confirm')}}</a></li>
                <li :class="{active:step===3,completed:step>3}"><a>{{$t('UpdateInfoTop.Complete')}}</a></li>
              </ul>
            </div>
            <div v-if="step===1||step==2">
              <div class="card mt-4">
                <div class="card-body">
                  <div class="">
                    <span>{{$t('UpdateInfoTop.text')}}</span>
                  </div>
                </div>
              </div>
              <div class="card mt-4 pt-3 pb-3">
                <div class="card-body">
                  <form label-width="0px" class="demo-ruleForm pt-4 needs-validation" novalidate>
                    <h5 class="card-title pt-3 pl-3 ">{{$t('UpdateInfoForm.UserInforTitle')}}</h5>
                    <nav class="navbar col-12">
                      <div class="col-12 col-md-4">
                        <label for="name" class="navbar-brand">{{$t('UpdateInfoForm.MyName')}}</label>
                      </div>
                      <div class="col-12 col-md-8">
                        <div class="col-12 p-0">
                          <input type="text" class="form-control" id="name" maxlength="128" v-model="userInfo.user_name" aria-label="username" aria-describedby="basic-addon2" :readonly="step===2" required>
                          <div class="invalid-feedback">
                            {{$t('UpdateInfoForm.MyNameTips')}}
                          </div>
                        </div>
                      </div>
                    </nav>
                    <nav class="navbar col-12">
                      <div class="col-12 col-md-4">
                        <label for="telephone" class="navbar-brand">{{$t('UpdateInfoForm.MyTelephone')}}</label>
                      </div>
                      <div class="col-12 col-md-8">
                        <div class="col-12 p-0">
                          <input type="tel" class="form-control" maxlength="128" id="telephone" v-model="userInfo.user_telephone" aria-describedby="basic-addon2" :readonly="step===2" required>
                          <div class="invalid-feedback">
                            {{$t('UpdateInfoForm.TelephoneTips1')}}
                          </div>
                        </div>
                      </div>
                    </nav>
                    <nav class="navbar col-12">
                      <div class="col-12 col-md-4">
                        <label for="language" class="navbar-brand">{{$t('UpdateInfoForm.language')}}</label>
                      </div>
                      <div class="form-inline col-12 col-md-8">
                        <div class="input-group col-12 p-0">
                          <select class="form-control" id="language" v-model="userInfo.language_code" aria-describedby="basic-addon2" :disabled="step===2">
                            <option value="en">{{$t('languageChoice.English')}}</option>
                            <option value="jp">{{$t('languageChoice.Japanese')}}</option>
                            <option value="zh">{{$t('languageChoice.Chinese')}}</option>
                          </select>
                        </div>
                      </div>
                    </nav>
                    <h5 class="card-title pt-3 pl-3 ">{{$t('UpdateInfoForm.FairFX')}}</h5>
                    <nav class="navbar navbar-light col-12">
                      <div class="col-12 col-md-4">
                        <label for="fairFX" class="navbar-brand">{{$t('UpdateInfoForm.FairFXNumber')}}</label>
                      </div>
                      <div class="form-inline col-12 col-md-8">
                        <div class="input-group col-12 p-0">
                          <input class="form-control" id="fairFX" maxlength="128" type="text" v-model="userInfo.fairfx_number" :readonly="step===2">
                        </div>
                      </div>
                    </nav>
                    <h5 class="card-title pt-3 pl-3 ">{{$t('UpdateInfoForm.BankAccount')}}</h5>
                    <nav class="navbar col-12">
                      <div class="col-12 col-md-4">
                        <label for="accountHolderName" class="navbar-brand">{{$t('UpdateInfoForm.accountHolderName')}}</label>
                      </div>
                      <div class="form-inline col-12 col-md-8">
                        <div class="input-group col-12 p-0">
                          <input type="text" class="form-control" maxlength="128" id="accountHolderName" v-model="userInfo.account_name" aria-describedby="basic-addon2" :readonly="step===2">
                        </div>
                      </div>
                    </nav>
                    <nav class="navbar col-12">
                      <div class="col-12 col-md-4">
                        <label for="firstName" class="navbar-brand">{{$t('UpdateInfoForm.firstName')}}</label>
                      </div>
                      <div class="form-inline col-12 col-md-8">
                        <div class="input-group col-12 p-0">
                          <input type="text" class="form-control" maxlength="128" id="firstName" v-model="userInfo.first_name" aria-describedby="basic-addon2" :readonly="step===2">
                        </div>
                      </div>
                    </nav>
                    <nav class="navbar col-12">
                      <div class="col-12 col-md-4">
                        <label for="lastName" class="navbar-brand">{{$t('UpdateInfoForm.lastName')}}</label>
                      </div>
                      <div class="form-inline col-12 col-md-8">
                        <div class="input-group col-12 p-0">
                          <input type="text" class="form-control" maxlength="128" id="lastName" v-model="userInfo.last_name" aria-describedby="basic-addon2" :readonly="step===2">
                        </div>
                      </div>
                    </nav>
                    <nav class="navbar col-12">
                      <div class="col-12 col-md-4">
                        <label for="street" class="navbar-brand">{{$t('UpdateInfoForm.myResidence')}}</label>
                      </div>
                      <div class="form-inline col-12 col-md-8">
                        <div class="input-group col-12 p-0">
                          <input class="form-control" id="street" maxlength="128" v-model="userInfo.account_street" aria-describedby="basic-addon2" :readonly="step===2">
                        </div>
                      </div>
                    </nav>
                    <nav class="navbar col-12">
                      <div class="col-12 col-md-4">
                        <label for="city" class="navbar-brand">{{$t('UpdateInfoForm.mycity')}}</label>
                      </div>
                      <div class="form-inline col-12 col-md-8">
                        <div class="input-group col-12 p-0">
                          <input type="text" class="form-control" maxlength="128" id="city" v-model="userInfo.account_city" aria-describedby="basic-addon2" :readonly="step===2">
                        </div>
                      </div>
                    </nav>
                    <nav class="navbar col-12">
                      <div class="col-12 col-md-4">
                        <label for="postcode" class="navbar-brand">{{$t('UpdateInfoForm.myPostalCode')}}</label>
                      </div>
                      <div class="form-inline col-12 col-md-8">
                        <div class="input-group col-12 p-0">
                          <input type="text" class="form-control" maxlength="128" id="postcode" v-model="userInfo.account_postcode" aria-describedby="basic-addon2" :readonly="step===2">
                        </div>
                      </div>
                    </nav>
                    <nav class="navbar col-12">
                      <div class="col-12 col-md-4">
                        <label for="country" class="navbar-brand">{{$t('UpdateInfoForm.mycountry')}}</label>
                      </div>
                      <div class="form-inline col-12 col-md-8">
                        <div class="input-group col-12 p-0">
                          <input type="text" class="form-control" id="country" v-model="userInfo.account_country" aria-describedby="basic-addon2" :readonly="step===2">
                        </div>
                      </div>
                    </nav>
                    <nav class="navbar col-12">
                      <div class="col-12 col-md-4">
                        <label for="accountNumber" class="navbar-brand">{{$t('UpdateInfoForm.accountNumber')}}</label>
                      </div>
                      <div class="form-inline col-12 col-md-8">
                        <div class="input-group col-12 p-0">
                          <input type="text" class="form-control" maxlength="128" id="accountNumber" v-model="userInfo.account_number" aria-describedby="basic-addon2" :readonly="step===2">
                        </div>
                      </div>
                    </nav>
                    <nav class="navbar col-12">
                      <div class="col-12 col-md-4">
                        <label for="bankName" class="navbar-brand">{{$t('UpdateInfoForm.bankName')}}</label>
                      </div>
                      <div class="form-inline col-12 col-md-8">
                        <div class="input-group col-12 p-0">
                          <input type="text" class="form-control" maxlength="128" id="bankName" v-model="userInfo.bank_name" aria-describedby="basic-addon2" :readonly="step===2">
                        </div>
                      </div>
                    </nav>
                    <nav class="navbar col-12">
                      <div class="col-12 col-md-4">
                        <label for="bankStreet" class="navbar-brand">{{$t('UpdateInfoForm.bankStreet')}}</label>
                      </div>
                      <div class="form-inline col-12 col-md-8">
                        <div class="input-group col-12 p-0">
                          <input type="text" class="form-control" maxlength="128" id="bankStreet" v-model="userInfo.bank_street" aria-describedby="basic-addon2" :readonly="step===2">
                        </div>
                      </div>
                    </nav>
                    <nav class="navbar col-12">
                      <div class="col-12 col-md-4">
                        <label for="bankCountry" class="navbar-brand">{{$t('UpdateInfoForm.bankCountry')}}</label>
                      </div>
                      <div class="form-inline col-12 col-md-8">
                        <div class="input-group col-12 p-0">
                          <input type="text" class="form-control" id="bankCountry" v-model="userInfo.bank_country" aria-describedby="basic-addon2" :readonly="step===2">
                        </div>
                      </div>
                    </nav>
                    <nav class="navbar col-12">
                      <div class="col-12 col-md-4">
                        <label for="bankSWIFT" class="navbar-brand">{{$t('UpdateInfoForm.bankSWIFT')}}</label>
                      </div>
                      <div class="form-inline col-12 col-md-8">
                        <div class="input-group p-0 col-12">
                          <input type="text" class="form-control" maxlength="128" id="bankSWIFT" style="border-bottom-right-radius:0.35rem;border-top-right-radius:0.35rem;" v-model="userInfo.bank_swift" aria-describedby="basic-addon2" :readonly="step===2">
                          <label for="routing" class="navbar-brand ml-3">{{$t('UpdateInfoForm.routing')}}</label>
                          <input type="text" class="form-control" maxlength="128" id="routing" style="border-bottom-left-radius:0.35rem;border-top-left-radius:0.35rem;" v-model="userInfo.bank_routing" aria-describedby="basic-addon2" :readonly="step===2">
                        </div>
                      </div>
                    </nav>
                    <nav class="navbar col-12">
                      <div class="col-12 col-md-4">
                        <label for="IBAN" class="navbar-brand">{{$t('UpdateInfoForm.IBAN')}}</label>
                      </div>
                      <div class="form-inline col-12 col-md-8">
                        <div class="input-group col-12 p-0">
                          <input type="text" class="form-control" maxlength="128" id="IBAN" v-model="userInfo.account_iban" aria-describedby="basic-addon2" :readonly="step===2">
                        </div>
                      </div>
                    </nav>
                    <nav class="navbar col-12">
                      <div class="col-12 col-md-4">
                        <label for="BACS" class="navbar-brand">{{$t('UpdateInfoForm.BACS')}}</label>
                      </div>
                      <div class="form-inline col-12 col-md-8">
                        <div class="custom-control custom-checkbox p-0 pl-4">
                          <input id="BACS" class="custom-control-input" type="checkbox" v-model="userInfo.bank_bacs_sepa" aria-label="Checkbox for following text input" :disabled="step===2">
                          <label class="custom-control-label" for="BACS"></label>
                        </div>
                      </div>
                    </nav>
                  </form>
                </div>
              </div>
            </div>
            <div v-if="step===3">
              <div class="card p-0 mt-4 pt-3 pb-3">
                <div class="p-5 text-center">
                  <p class="lead">{{$t('UpdateComplete.Complete')}}</p>
                  <hr class="my-4 display-4">
                  <router-link to="/user/info" class="btn btn-lg btn-primary">{{$t('UpdateComplete.ReturnSettings')}}</router-link>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-4 col-12 p-0 no-gutters">
            <div class="col-6" v-if="step<3">
              <button class="btn btn-outline-secondary" @click="clickBack">{{$t('UpdateInfoForm.Backbtn')}}</button>
            </div>
            <div class="col-6 text-right p-0" v-if="step===1">
              <button class="btn btn-primary" @click="validator">{{$t('UpdateInfoForm.Confirmbtn')}}</button>
            </div>
            <div class="col-6 text-right p-0" v-if="step===2">
              <button class="btn btn-primary" @click="changeInfo">{{$t('UpdateInfoForm.Changebtn')}}</button>
            </div>
          </div>
        </div>
      </div>
    </main>
    <copyright></copyright>
    <form label-width="0px" class="demo-ruleForm needs-validation" novalidate>
      <div class="modal fade" id="authenticatorModal" tabindex="-1" role="dialog" aria-labelledby="authenticatorModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title" id="authenticatorModalLabel">
                {{$t('TwiceVerification.twiceVerification')}}
              </h4>
            </div>
            <div class="modal-body pt-5 pb-5">
              <div class="form-group">
                <small>{{$t('TwiceVerification.verificationCodeExplainInfo')}}</small><br><br>
                <label for="verificationCodeStep2">
                  <h5>{{$t('TwiceVerification.verificationCode')}}</h5>
                </label>
                <input class="form-control form-control-lg mt-2" v-model="verificationCode" id="verificationCodeStep2" required />
                <div class="invalid-feedback">
                  {{$t('TwiceVerification.verificationCodeRequired')}}
                </div>
              </div>
            </div>
            <div class="modal-footer pt-5 pb-3">
              <div class="col-6">
                <button type="button" class="btn btn-lg btn-outline-secondary" data-dismiss="modal">{{$t('modal.modalCancel')}}
                </button>
              </div>
              <div class="col-6 text-right">
                <button class="btn btn-lg btn-primary" type="submit" @click="userInfoUpdate">{{$t('TwiceVerification.modalSubmit')}}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>

  </div>
</template>

<style src="../../../static/css/dashboard.css" />
<script type="text/javascript">
import navbar from './navbar'
import copyright from './copyright'
import { NmsClient, RestCfg } from '../../scripts/AllExport'
var userInfoGetReqType = 'user-info-get'
var userInfoUpdateReqType = 'user-info-update'
export default {
  components: { navbar, copyright },
  data: function () {
    return {
      step: 1,
      confirmed: false,
      steps: [
        'step1',
        'step2',
        'step3'
      ],
      userInfo: '',
      verificationCode: ''
    }
  },
  mounted() {
    $('#authenticatorModal').on('hidden.bs.modal', (event) => {
      this.verificationCode = ''
      if ($('.needs-validation')[1] !== undefined) {
        $('.needs-validation')[1].classList.remove('was-validated')
      }
    })
    $('[data-toggle="tooltip"]').tooltip()
    $(function () { $("[data-toggle='popover']").popover() })
    $('.popover-dismiss').popover({
      trigger: 'focus'
    })
    this.init()
  },
  methods: {
    changeInfo() {
      $('#authenticatorModal').modal('show')
    },
    clickBack() {
      if (this.step === 1) {
        this.$router.push({ path: '/user/info' })
      } else {
        this.step--
      }
    },
    init() {
      NmsClient.send(
        RestCfg.POST,
        {
          'reqType': userInfoGetReqType
        },
        this.userInfoGetResult,
        null
      )
    },
    userInfoGetResult(response) {
      let result = response.resultInfo[0]
      this.userInfo = result
      this.userInfo.bank_bacs_sepa = this.userInfo.bank_bacs_sepa === 1
      this.userInfo.language_code = this.userInfo.language_code === '' || this.userInfo.language_code === null ? 'en' : this.userInfo.language_code
    },
    userInfoUpdate() {
      let form = $('.needs-validation')[1]

      form.onsubmit = (event) => {
        event.preventDefault()
        if (form.checkValidity()) {
          let userInfo = {...this.userInfo}
          userInfo.bank_bacs_sepa ? userInfo.bank_bacs_sepa = 1 : userInfo.bank_bacs_sepa = 0
          NmsClient.send(
            RestCfg.POST,
            {
              'reqType': userInfoUpdateReqType,
              'userInfo': userInfo,
              'verificationCode': this.verificationCode
            },
            (response) => {
              this.step++
              $('#authenticatorModal').modal('hide')
            },
            null
          )
        }
        form.classList.add('was-validated')
      }
    },
    validator() {
      let formValidation = $('.needs-validation')[0]
      if (formValidation.checkValidity()) {
        this.step++
        formValidation.classList.remove('was-validated')
      } else {
        formValidation.classList.add('was-validated')
        if ($('.form-control:invalid').length !== 0) $('.form-control:invalid')[0].focus()
      }
    }
  },
  watch: {
    step (newStep, oldStep) {
      $(function () { $("[data-toggle='popover']").popover() })
    }
  }

}
</script>
<style scoped>
.navbar {
    font-weight: normal;
}
.navbar-brand button{
  background-color: white;
}
.navbar-brand {
  font-size: 1.25rem;
}
@media(min-width:0px) {
  .nav-tabs.wizard li {
    position: relative;
    padding: 0;
    margin: 1px 4px 1px 0;
    width: 31.3%;
    float: left;
    text-align: center;
  }

  .nav-tabs.wizard>li:last-child>a {
    width: calc(31.3% + 21px);
  }
}
.nav-tabs.wizard>li:last-child>a {
  width: calc(100% + 21px);
}
.container{
  min-height:calc(100vh - 256px)
}
</style>



// WEBPACK FOOTER //
// src/components/user/update-info.vue